<template>
  <div>
    <a-card size="small" title="处理器映射配置">
        <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>
        <a-button slot="extra" type="primary" style="margin-left:20px;" @click="handleRefresh">刷新配置</a-button>

        <searchE @handleSearch="handleSubmit"></searchE>

        <tableE ref="cpuTableID" :platForms="platforms"></tableE>

        <a-modal title="刷新配置" :visible="isShow" :confirm-loading="confirmLoading" width="300px"
            @cancel="handleCancel">
            <label for="">选择领域：</label>
            <a-select v-model="domain" style="width: 80px">
                <a-select-option value="001">前台</a-select-option>
                <a-select-option value="002">中台</a-select-option>
                <a-select-option value="003">开放</a-select-option>
                <a-select-option value="004">基础</a-select-option>
            </a-select>

            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    刷新
                </a-button>
            </template>
        </a-modal>
    </a-card>

     
  </div>
</template>
<script>

import searchE from './search'
import tableE from './table'
export default {
    data() {
        return {
            searchP:{},
            platforms:[],
            isShow:false,
            confirmLoading:false,
            domain:'001',
        };
    },
    methods: {
        handleSubmit(searchP){
            this.$refs.cpuTableID.handleSearch(searchP);
        },
        handleNew(){
            this.$router.push({
                path: "add_processor",
                query: {id:''}
            });
        },
        handleRefresh(){
            this.isShow = true;
        },
        handleCancel(){
            this.isShow = false;
        },
        handleOk(){
            console.log(this.domain)
            let that = this;
            that.$store.dispatch({
                type: "servicekey/processorRefresh",
                params: {domain: that.domain}
            }).then((res) => {
                if (res.status == '200') {
                    that.message.success('刷新成功')
                    that.isShow = false;
                }
            });
        }
    },
    components:{
        searchE,
        tableE
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
